import { RequestStatusEnum } from "../types/enums";

export function getBadgeColorForEngagementRequestStatus(statusId?: number) {
    switch (statusId) {
        case RequestStatusEnum.Requested:
            return "purple";
        case RequestStatusEnum.Rejected:
            return "red";
        case RequestStatusEnum.Completed:
            return "green";
        default:
            return "gray";
    }
}

export function isRequestComplete(statusId?: number) {
    switch (statusId) {
        case RequestStatusEnum.Requested:
            return false;
        case RequestStatusEnum.Rejected:
        case RequestStatusEnum.Completed:
            return true;
        default:
            return false;
    }
}

export const mapDateFromDateOnly = (dateOnly: string) => {
    const arr = dateOnly.split("-");
    return new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]));
};

export function isOverdue(dueDate: string | null | undefined) {
    if (!dueDate) {
        return false;
    }
    const dueRealDt = mapDateFromDateOnly(dueDate);

    const base = new Date();
    const now = new Date(base.getFullYear(), base.getMonth(), base.getDate());

    return dueRealDt.getTime() < now.getTime();
}

export function isWithinOneWeek(dueDate: string | null | undefined) {
    if (!dueDate) {
        return false;
    }
    const dueRealDt = mapDateFromDateOnly(dueDate);
    const base = new Date();

    const oneWeek = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    const oneWeekNum = oneWeek.setDate(oneWeek.getDate() + 7);

    const nowNum = new Date(base.getFullYear(), base.getMonth(), base.getDate()).getTime();
    const dueDateNum = dueRealDt.getTime();
    return dueDateNum <= oneWeekNum && dueDateNum >= nowNum;
}

export function isWithinTwoWeeks(dueDate: string | null | undefined) {
    if (!dueDate) {
        return false;
    }
    const dueRealDt = mapDateFromDateOnly(dueDate);
    const base = new Date();

    const oneWeek = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    const oneWeekNum = oneWeek.setDate(oneWeek.getDate() + 7);

    const twoWeeks = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    const twoWeeksNum = twoWeeks.setDate(twoWeeks.getDate() + 14);

    const dueDateNum = dueRealDt.getTime();
    return dueDateNum <= twoWeeksNum && dueDateNum > oneWeekNum;
}

export function isFuture(dueDate: string | null | undefined) {
    if (!dueDate) {
        return false;
    }
    const dueRealDt = mapDateFromDateOnly(dueDate);
    const base = new Date();

    const now = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    const twoWeeks = now.setDate(now.getDate() + 14);
    return dueRealDt.getTime() > twoWeeks;
}

export const getRequestTypeName = (requestType: { id: number; name: string } | undefined): string => {
    if (!requestType) {
        return "";
    }
    switch (requestType.id) {
        case 1:
            return "Document Request";
        case 3:
            return "Dynamic Question";
        default:
            return requestType.name;
    }
};

export const getImportValidationFile = (fileByteString: string): Blob => {
    const byteCharacters = atob(fileByteString);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset++) {
        byteArrays.push(byteCharacters.charCodeAt(offset));
    }
    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
};
